import React, { useState } from "react";

// Components imports
import InputField from "../../../common/InputField";

// Scss imports
import css from "./IndividualBasicData.module.scss";

interface IndividualBasicDataProps {
  firstName: string;
  lastName: string;
  nationalId: string;
  identificationNumberE: string;
  taxIdE: string;
  handleChange: Function;
  errorText: string;
  firstNameError;
  lastNameError;
  nationalIdError;
  identificationNumberEError;
  taxIdEError;
}

const IndividualBasicData: React.FC<IndividualBasicDataProps> = ({
  firstName,
  lastName,
  nationalId,
  identificationNumberE,
  taxIdE,
  handleChange,
  errorText,
  firstNameError,
  lastNameError,
  nationalIdError,
  identificationNumberEError,
  taxIdEError,
}) => {
  // Set state to check if user is contractor
  const [contractor, setContractor] = useState(false);

  return (
    <div className={css.container}>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Име"
          name="firstName"
          id="name"
          type="text"
          placeholder="Иван"
          value={firstName}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "Влада")}
          errorText={firstNameError}
        />
      </div>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Презиме"
          name="lastName"
          id="lastName"
          type="text"
          placeholder="Лукић"
          value={lastName}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "Митић")}
          errorText={lastNameError}
        />
      </div>
      <div className={css.inputFieldWrapper}>
        {/*<InputField
          label="Јмбг"
          name="nationalId"
          id="nationalId"
          type="text"
          placeholder="4843943394934934934"
          value={nationalId}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) =>
            (e.target.placeholder = "4843943394934934934")
          }
          errorText={nationalIdError}
        />*/}
      </div>
      <p
        className={css.orangeText}
        onClick={() => setContractor((prevState) => !prevState)}
      >
        Предузетник
      </p>
      {/*contractor && (
        <div className={css.inputFieldWrapper}>
          <InputField
            label="Матични број предузетника"
            name="identificationNumberE"
            id="identificationNumberE"
            type="text"
            placeholder="563964333"
            value={identificationNumberE}
            handleChange={handleChange}
            handleOnFocus={(e: any) => (e.target.placeholder = "")}
            handleOnBlur={(e: any) => (e.target.placeholder = "563964333")}
            errorText={
              identificationNumberE.length > 1 ? identificationNumberEError : ""
            }
          />
        </div>
          )*/}
      {contractor && (
        <div className={css.inputFieldWrapper}>
          <InputField
            label="ПИБ"
            name="taxIdE"
            id="taxIdE"
            type="text"
            placeholder="54344333"
            value={taxIdE}
            handleChange={handleChange}
            handleOnFocus={(e: any) => (e.target.placeholder = "")}
            handleOnBlur={(e: any) => (e.target.placeholder = "54344333")}
            errorText={taxIdE.length > 1 ? taxIdEError : ""}
          />
        </div>
      )}
    </div>
  );
};

export default IndividualBasicData;
